<ng-container *ngIf="card">
    <div class="flex {{ card?.classes ?? '' }} relative rounded-xl overflow-hidden shadow-lg ease-in-out delay-75 transition" >
        <div class="absolute right-0 rotate-45 opacity-15">
            <fa-icon [icon]="card.icon" class=" text-9xl "></fa-icon>
        </div>
        <div class="flex gap-5 p-12 rounded-lg items-center">
            <fa-icon [icon]="card.icon" class="text-3xl"></fa-icon>
            <div class="flex flex-col gap-2">
                <span class="text-3xl font-extrabold">{{card.value}}</span>
                <span class="font-bold"> {{card.title}}</span>
            </div>
        </div>
    </div>
</ng-container>
